class MonogramTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;
    if (!this.form) return;

    this.handleClick = (e) => {
      const formData = new FormData(this.form);

      const selectedVariant = formData.get("id");

      if ("requireSelect" in this.dataset && !selectedVariant) {
        this.innerHTML = this.dataset.requireSelect;
        return;
      }

      const html = `<monogram-config product-id="${this.productId}" current-variant-id="${this.currentVariantId}"></monogram-config>`;

      this.button.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { html, target: "monogram-modal" },
        }),
      );
    };

    this.button.addEventListener("click", this.handleClick);
  }

  connectedCallback() {}

  disconnectedCallback() {}

  get productId() {
    return this.getAttribute("product-id");
  }

  get currentVariantId() {
    return this.getAttribute("current-variant-id");
  }
}

if (!customElements.get("monogram-trigger")) {
  customElements.define("monogram-trigger", MonogramTrigger);
}
